import API from '@/shared/helpers/API.js';
import {getLocalDateFromServer} from "@/shared/helpers/dates";
import {setParam} from "@/shared/helpers/events";

export const userStoreActions = {

	logout(callback = null) {
		API.init().logout((response) => {
			// Clear storage
			sessionStorage.removeItem('oauth_token');
			sessionStorage.removeItem('user_id');
			localStorage.removeItem("refresh_token");
			localStorage.removeItem("current-business-id");

			// Clear GTM user_id
			setParam('user_id', undefined);

			if(typeof Android !== "undefined" && Android.hasSecondScreen && Android.hasSecondScreen()) {
				Android.hideSecondScreen();
			}

			// Execute callback if provided (with boolean result)
			if (callback) {
				callback(response && response.result === "OK");
			}

			// Redirect to login
			window.location.replace(URL_HTML + "/console/login/");
		});
	},

	init(self, redirectUrlAuth = null, kickIfNotLogged = true) {

		let fullRedirectUrl = URL_HTML + "/console/login/";
		if(redirectUrlAuth) {
			fullRedirectUrl += "?redirect_url_auth=" + encodeURIComponent(redirectUrlAuth);
		}

		// Check for token in get_params (for cross-domain super user login via params.php)
		let get_params = JSON.parse(sessionStorage.getItem('get_params'));
		if(get_params && get_params.login_token) {
			sessionStorage.setItem('oauth_token', get_params.login_token);
			// Remove token from get_params to avoid keeping it in storage
			delete get_params.login_token;
			sessionStorage.setItem('get_params', JSON.stringify(get_params));
		}

		let oauthToken = sessionStorage.getItem('oauth_token');
		if(!oauthToken || oauthToken === "") {
			let refreshToken = localStorage.getItem('refresh_token');
			if(refreshToken && refreshToken !== "") {
				API.init(URL_HTML, fullRedirectUrl).loginUserRefreshToken(refreshToken, function (response) {
					if ("access_token" in response) {
						sessionStorage.setItem("oauth_token", response.access_token);
						API.init().oauthToken = response.access_token;
						if (!API.init().oauthToken || API.init().oauthToken === "") {
							window.location.replace(fullRedirectUrl);
						}
						self.refreshUserAccount();
					} else {
						localStorage.removeItem("refresh_token");
						if(kickIfNotLogged) {
							window.location.replace(fullRedirectUrl);
						}
					}

				});
			} else {
				if(kickIfNotLogged) {
					window.location.replace(fullRedirectUrl);
				}
			}

		} else {

			API.init(URL_HTML, fullRedirectUrl).oauthToken = oauthToken;
			self.refreshUserAccount();

		}

	},
	normalizeBusiness(business) {
		if(!business) {
			return null;
		}
		business.link = business.link || null;
		business.plan_cycle = business.plan_cycle || null;
		business.counter_shortcut = business.counter_shortcut || null;
		business.notification_sound = business.notification_sound || null;
		business.payout_interval = business.payout_interval || null;
		business.reservations_questions = business.reservations_questions || null;
		business.reservations_request_card = business.reservations_request_card || null;
		business.registrationDate = getLocalDateFromServer(business.registration_date);
		business.stripe_account_deadline = business.stripe_account_deadline ? getLocalDateFromServer(business.stripe_account_deadline) : null;
		business.stripe_account_details_submitted = business.stripe_account_details_submitted === 1;
		business.stripe_account_highest_requirement = business?.stripe_account_highest_requirement || null;

		if(business.counter_manual_cutoff_date) {
			business.counter_manual_cutoff_date = getLocalDateFromServer(business.counter_manual_cutoff_date, false);
			business.counter_manual_cutoff_date.setHours(0,0,0,0);
		} else {
			business.counter_manual_cutoff_date = null;
		}

		business.webhooks = business.webhooks ? this.normalizeWebhooks(business.webhooks) : [];

		if (business.webhook_types) {
			let webhookTypesMap = {};
			business.webhook_types.forEach(webhookType => {
				let webhookId = parseInt(webhookType.business_webhook_id);
				if (webhookTypesMap.hasOwnProperty(webhookId)) {
					webhookTypesMap[webhookId].push(webhookType.event_type);
				}
				else {
					webhookTypesMap[webhookId] = [webhookType.event_type];
				}
			});
			business.webhook_types = webhookTypesMap;
		}
		else {
			business.webhook_types = {};
		}

		business.customer_completable_order = Number(business.customer_completable_order);
		business.satispay_status = Number(business.satispay_status);
		business.menu_language_id = Number(business.menu_language_id);
		business.issuing_max_virtual = Number(business.issuing_max_virtual);
		business.issuing_max_physical = Number(business.issuing_max_physical);
		business.delivery_courier_pickup_delay = business.delivery_courier_pickup_delay ? Number(business.delivery_courier_pickup_delay) : 1;

		business.delivery_courier_free_shipping = business.delivery_courier_free_shipping ? Number(business.delivery_courier_free_shipping) : null;
		business.address_id = business.address_id ? Number(business.address_id) : null;
		business.address = business.address ? this.normalizeAddress(business.address) : null;
		business.legal_address_id = business.legal_address_id ? Number(business.legal_address_id) : null;
		business.legal_address = business.legal_address ? this.normalizeAddress(business.legal_address) : null;
		business.split_payment_invoicing = business.split_payment_invoicing === 1;
		business.min_order = business.min_order ? Number(business.min_order) : null;
		business.open_balance = business.open_balance ? Number(business.open_balance) : null;
		business.stripe_balance_available = business.stripe_balance_available ? Number(business.stripe_balance_available) : null;
		business.stripe_balance_pending = business.stripe_balance_pending ? Number(business.stripe_balance_pending) : null;
		business.payout_delay = business.payout_delay ? Number(business.payout_delay) : null;
		business.takeaway_costs = business.takeaway_costs ? Number(business.takeaway_costs) : null;
		business.takeaway_min_order = business.takeaway_min_order ? Number(business.takeaway_min_order) : null;
		business.takeaway_future_days = business.takeaway_future_days ? Number(business.takeaway_future_days) : null;
		business.delivery_distance = business.delivery_distance ? Number(business.delivery_distance) : null;
		business.delivery_costs = business.delivery_costs ? Number(business.delivery_costs) : null;
		business.delivery_min_order = business.delivery_min_order ? Number(business.delivery_min_order) : null;
		business.delivery_future_days = business.delivery_future_days ? Number(business.delivery_future_days) : null;
		business.preparation_time = business.preparation_time ? Number(business.preparation_time) : null;
		business.integration_id = business.integration_id ? Number(business.integration_id) : null;
		business.default_menu_id = business.default_menu_id ? Number(business.default_menu_id) : null;
		business.stripe_owner = business.stripe_owner ? Number(business.stripe_owner) : null;
		business.delivery_courier_free_shipping = business.delivery_courier_free_shipping ? Number(business.delivery_courier_free_shipping) : null;
		business.default_stripe_location_id = business.default_stripe_location_id ? Number(business.default_stripe_location_id) : null;
		business.most_sold_quantity = business.most_sold_quantity ? Number(business.most_sold_quantity) : null;
		business.buffer_time = business.buffer_time ? Number(business.buffer_time) : null;
		business.apifattura_id = business.apifattura_id ? Number(business.apifattura_id) : null;
		business.apiscontrino_id = business.apiscontrino_id ? Number(business.apiscontrino_id) : null;
		business.reservations_cancel = business.reservations_cancel ? Number(business.reservations_cancel) : null;
		business.reservations_penalty = business.reservations_penalty ? Number(business.reservations_penalty) : null;
		business.counter_manual_code = business.counter_manual_code ? business.counter_manual_code : null;
		business.counter_pay_later = business.counter_pay_later === 1;
		business.counter_ticket = business.counter_ticket === 1;
		business.counter_satispay = business.counter_satispay === 1;
		business.counter_wire_transfer = business.counter_wire_transfer === 1;
		business.counter_check = business.counter_check === 1;
		business.counter_allow_prepared = business.counter_allow_prepared === 1;

		business.cross_selling = business.cross_selling === 1;
		business.cross_selling_popup = business.cross_selling_popup === 1;
		business.buffer_customers = business.buffer_customers === 1;
		business.autocomplete_payed_counter = business.autocomplete_payed_counter === 1;
		business.counter_complete_orders_close = business.counter_complete_orders_close === 1;
		business.counter_mandatory_table = business.counter_mandatory_table === 1;
		business.show_counter_numpad = business.show_counter_numpad === 1;
		business.counter_courses = business.counter_courses === 1;
		business.counter_single_item_prepared = business.counter_single_item_prepared === 1;
		business.counter_manual = business.counter_manual === 1;
		business.allergens_filter = business.allergens_filter === 1;
		business.disable_feedbacks = business.disable_feedbacks === 1;
		business.private_feedbacks = business.private_feedbacks === 1;
		business.queue_active_menu = business.queue_active_menu === 1;
		business.queue_active_summary = business.queue_active_summary === 1;
		business.accept_cash = business.accept_cash === 1;
		business.accept_cards = business.accept_cards === 1;
		business.accept_klarna = business.accept_klarna === 1;
		business.accept_voucherly = business.accept_voucherly === 1;
		business.accept_satispay = business.accept_satispay === 1;
		business.enabled_box_email_cash = business.enabled_box_email_cash === 1;
		business.sms_qr_table = business.sms_qr_table === 1;
		business.sms_qr_seat = business.sms_qr_seat === 1;
		business.sms_qr_area = business.sms_qr_area === 1;
		business.sms_qr_name = business.sms_qr_name === 1;
		business.sms_qr_single_table = business.sms_qr_single_table === 1;
		business.autocomplete_old_orders = business.autocomplete_old_orders === 1;
		business.allow_request_invoice = business.allow_request_invoice === 1;
		business.coupons = business.coupons === 1;
		business.takeaway = business.takeaway === 1;
		business.takeaway_cash = business.takeaway_cash === 1;
		business.takeaway_enabled_sms = business.takeaway_enabled_sms === 1;
		business.delivery = business.delivery === 1;
		business.delivery_cash = business.delivery_cash === 1;
		business.delivery_courier = business.delivery_courier === 1;
		business.force_privacy = business.force_privacy === 1;
		business.show_order_qr = business.show_order_qr === 1;
		business.enabled_search = business.enabled_search === 1;
		business.read_mode = business.read_mode === 1;
		business.menu_reservations_link = business.menu_reservations_link === 1;
		business.config_menu = business.config_menu === 1;
		business.config_tables = business.config_tables === 1;
		business.config_payments = business.config_payments === 1;
		business.config_settings = business.config_settings === 1;
		business.plan_plugin_order_pay = business.plan_plugin_order_pay === 1;
		business.plan_plugin_delivery = business.plan_plugin_delivery === 1;
		business.plan_plugin_takeaway = business.plan_plugin_takeaway === 1;
		business.plan_plugin_pos = business.plan_plugin_pos === 1;
		business.plan_plugin_counter = business.plan_plugin_counter === 1;
		business.plan_plugin_pay_bill = business.plan_plugin_pay_bill === 1;
		business.hide_prices = business.hide_prices === 1;
		business.hide_notes = business.hide_notes === 1;
		business.print_cash_unaccepted = business.print_cash_unaccepted === 1;
		business.print_auto_prebill = business.print_auto_prebill === 1;
		business.print_orders_preparation_time = business.print_orders_preparation_time === 1;
		business.google_merchant_feed_active = business.google_merchant_feed_active === 1;
		business.block_orders = business.block_orders === 1;
		business.deleted = business.deleted === 1;
		business.stripe_trial = business.stripe_trial === 1;
		business.counter_hide_secondary = business.counter_hide_secondary === 1;
		business.counter_hide_subtotal = business.counter_hide_subtotal === 1;
		business.counter_images = business.counter_images === 1;
		business.reservations_manual = business.reservations_manual === 1;
		business.counter_variations_limits = business.counter_variations_limits === 1;
		business.require_code = business.require_code === 1;
		business.weekly_cash_transactions = Number(business?.weekly_cash_transactions || 0);

		return business;
	},
	normalizeAddress(address) {
		address.address = address.address ? address.address : null;
		address.address_id = address.address_id ? Number(address.address_id) : null;
		address.user_id = address.user_id ? Number(address.user_id) : null;
		address.lat = address.lat ? Number(address.lat) : null;
		address.lng = address.lng ? Number(address.lng) : null;
		address.civico = address.civico || null;
		address.comune = address.comune || null;
		address.details = address.details || null;
		address.provincia = address.provincia || null;
		address.provincia_codice = address.provincia_codice || null;
		address.regione = address.regione || null;
		address.via = address.via || null;
		address.zip = address.zip || null;
		address.date = address.date || null;
		address.deleted = address.deleted === 1;

		return address;
	},
	normalizeWebhooks(webhooks) {
		if(!webhooks || !webhooks.length) {
			return [];
		}
		return webhooks.map(w => {
			w.business_webhook_id = w.business_webhook_id ? Number(w.business_webhook_id) : null;
			w.name = w.name || null;
			w.url = w.url || null;
			w.auth = w.auth || null;
			w.type = w.type || null;
			return w;
		});
	},
	normalizeUnpaidInvoices(invoices) {
		if(!invoices || !invoices.length) {
			return [];
		}
		return invoices.map(i => {
			i.stripe_invoice_id = Number(i.stripe_invoice_id);
			i.business_id = Number(i.business_id);
			i.is_metered = i.is_metered === 1;
			i.amount_due = i?.amount_due ? Number(i.amount_due) : 0;
			i.paid = i.paid === 1;
			return i;
		});
	},
	normalizeUser(user) {
		if(!user) {
			return null;
		}
		let returningUser = {};
		returningUser.credit = user.credit ? Number(user.credit) : null;
		returningUser.email = user.email || null;
		returningUser.name = user.name || null;
		returningUser.phone = user.phone || null;
		returningUser.stripe_customer = user.stripe_customer || null;
		returningUser.stripe_trial = user.stripe_trial=== 1;
		returningUser.tfa_secret = user.tfa_secret || null;
		returningUser.user_id = user.user_id ? Number(user.user_id) : null;

		return returningUser;
	},
	refreshUserAccount(self, callback = null) {
		if(typeof window.userData !== "undefined" && window.userData && window.userData.result === "OK" && window.userData.user && window.userData.businesses) {
			this.postRefreshUserAccount(self, window.userData, callback);
			window.userData = null;
		} else {
			API.init().userAccount((response) => {
				if (response && response.result === "OK" && response.user && response.businesses) {
					this.postRefreshUserAccount(self, response, callback);
				}
			});
		}
	},
	changeBusinessCountryConsoleLink(businessCountry) {
		if(!businessCountry || !businessCountry?.toUpperCase || typeof COUNTRIES === 'undefined') { return false; }
		let finalCountry = null;
		for (let countryKey in COUNTRIES) {
			if(businessCountry.toUpperCase() === COUNTRIES[countryKey].country) {
				finalCountry = COUNTRIES[countryKey];
				break;
			}
		}
		if(finalCountry && COUNTRY !== finalCountry.country) {
			let protocol = (location?.protocol || "https:") + "//";
			return protocol + finalCountry.host;
		}
		return false;
	},
	postRefreshUserAccount(self, response, callback = null) {
		self.user = response.user;
		let presetBusinessId = null;
		let getParamBusinessId = null;
		let get_params = JSON.parse(sessionStorage.getItem('get_params'));
		if(get_params && get_params.business_id) {
			getParamBusinessId = get_params.business_id;
		}

		for(let businessId in response.businesses) {
			self.normalizeBusiness(response.businesses[businessId]);
			if(getParamBusinessId && !presetBusinessId && businessId === getParamBusinessId) {
				presetBusinessId = businessId;
			}
		}
		self.businesses = response.businesses;

		let keys = Object.keys(self.businesses);
		self.noBusinesses = keys.length === 0;

		let storageBusinessId = localStorage.getItem('current-business-id');
		if(!presetBusinessId) {
			if (!self.businesses[storageBusinessId]) {
				storageBusinessId = null;
			}
		}

		let id = presetBusinessId || storageBusinessId || (keys.length ? keys[0] : null);
		if(!id || !self.businesses[id]) { return }
		self.currBusinessId = id;

		if(typeof Android !== "undefined" && Android.hasSecondScreen && Android.hasSecondScreen()) {
			Android.showSecondScreen("");
			Android.navigateSecondScreen("/console/second-display/");
		}

		if(self.currBusiness && self.currBusiness?.country && self.currBusiness?.country !== COUNTRY) {
			//SWITCH TO THE FIRST BUSINESS ON THE SAME COUNTRY
			//IF NO BUSINESSES ON SAME COUNTRY, LOGOUT
			let correctCountryId = null;
			for(let businessId in self.businesses) {
				if(self.businesses[businessId].country === COUNTRY) {
					correctCountryId = businessId;
					break;
				}
			}
			if(!correctCountryId) {
				this.logout();
			} else {
				self.changeBusiness(correctCountryId);
				callback && callback();
			}

		} else {
			this.getBusinessUnpaidInvoices(self);
			localStorage.setItem('current-business-id', id);
			callback && callback();
		}
	},
	refreshBusiness(self, businessId, callback = null) {
		API.init().getBusiness(businessId, function (response) {
			if (response && response.result === "OK") {
				self.normalizeBusiness(response.business);
				self.businesses[businessId] = response.business;
				callback && callback();
			}
		});
	},
	getBusinessUsers(self, callback = null) {
		if(!self.currBusinessId) {
			return;
		}
		self.businessUsers = {};
		API.init().getBusinessUsers(self.currBusinessId, function (r) {
			if (r && r.users && r.users.length) {
				//group users by user_id
				for (let i = 0; i < r.users.length; i++) {
					let currUser = r.users[i];
					currUser.station = currUser.station === 1;
					self.businessUsers[currUser.user_id] = currUser;
				}
			}
			if(callback) {
				callback(self.businessUsers);
			}
		});
	},
	getBusinessLocation(self, callback = null) {
		if(self.default_stripe_location_id) {
			callback && callback(self.default_stripe_location_id, null);
		} else {
			API.init().getBusinessLocation(self.currBusinessId, function (r) {
				if (r && r.result === "OK" && r.location_id) {
					self.default_stripe_location_id = r.location_id;
					callback && callback(r.location_id, null);
				} else {
					if(r && r.result === "KO" && r.details) {
						callback && callback(null, r.details);
					} else {
						callback && callback(null, null);
					}
				}
			});
		}
	},
	getBusinessUnpaidInvoices(self, callback = null) {
		if(!self.currBusinessId) {
			return;
		}
		API.init().getBusinessUnpaidInvoices(self.currBusinessId, r => {
			self.unpaidInvoices = [];
			if (r && r.result === "OK" && r?.unpaid_invoices?.length) {
				self.unpaidInvoices = this.normalizeUnpaidInvoices(r.unpaid_invoices);
			}
			callback && callback();
		});
	}
}

export const userStoreGetters = {
	currBusiness(state) {
		if(!state.currBusinessId || !state.businesses) {
			return null;
		}
		return state.businesses[state.currBusinessId];
	},
	currPermissions(state) {
		let permissions = [];
		let unlockUserCheck = state.unlockUserId && state.businessUsers[state.unlockUserId] === null;
		if(!state || !state.currBusiness || !state.currBusiness.permissions || !state.currBusiness.permissions.length || unlockUserCheck) {
			return permissions;
		}

		if (state.unlockUserId && state.businessUsers[state.unlockUserId]) {
			permissions = state.businessUsers[state.unlockUserId].permission;
		}
		else {
			permissions = state.currBusiness.permissions;
		}

		return permissions;
	}
}
